var mp = mp || {};

// Toast messages
// WooCommerce notices printed into [data-toasts] (footer.php) and messages added with mp.toast()
// Success / info hide after a few seconds, errors stay until closed
//-----------------------------------------------------------------
mp.toastDuration = 3000;

mp.toast = function ($toast) {
  var $container = $("[data-toasts]");

  if (!$container.length) {
    return;
  }

  if (!$toast.parent().is($container)) {
    $container.append($toast);
  }

  $toast.addClass("toast").append('<button type="button" class="toast__close" aria-label="Zatvori">&times;</button>');

  function hide() {
    $toast.removeClass("is-visible");
    setTimeout(function () {
      $toast.remove();
    }, 300);
  }

  $toast.on("click", ".toast__close", hide);

  // Next frame, so the show transition runs
  setTimeout(function () {
    $toast.addClass("is-visible");
  }, 20);

  if (!$toast.hasClass("woocommerce-error")) {
    var timer = setTimeout(hide, mp.toastDuration);

    // Keep it open while hovered
    $toast.on("mouseenter", function () {
      clearTimeout(timer);
    });
    $toast.on("mouseleave", function () {
      timer = setTimeout(hide, mp.toastDuration);
    });
  }
};

mp.toasts = function () {
  var $container = $("[data-toasts]");

  if (!$container.length) {
    return;
  }

  // Notices from the page load (e.g. after adding a product to cart)
  $container.children(".woocommerce-message, .woocommerce-info, .woocommerce-error").each(function () {
    mp.toast($(this));
  });

  // AJAX add to cart buttons
  $(document.body).on("added_to_cart", function () {
    mp.toast(
      $('<div class="woocommerce-message" role="alert"></div>').html(
        '<span class="toast__text">Proizvod je dodan u košaricu.</span>'
      )
    );
  });
};
